import { User } from '@auth0/auth0-react';

export enum AccessRoles {
  ONLINE_CAMPAIGNS = 'Online-Campaigns',
  FAIR_VALUE = 'Fair-Value',
  FULL_ACCESS = 'Full-Access',
  META_RF_RESERVATION = 'Meta-RF-Reservation',
  APPROVAL_ACCESS = 'Approval-Access',
  CPD_DIVISION_ACCESS = 'CPD-Division-Access',
  LDB_DIVISION_ACCESS = 'LDB-Division-Access',
  PPD_DIVISION_ACCESS = 'PPD-Division-Access',
  LPD_DIVISION_ACCESS = 'LPD-Division-Access',
}

export type MediaCalculatorUser = User & {
  'media-calculator/roles': AccessRoles[];
};
